/** Kill switch for all client-side bot deterrence on the login form. */
export const BOT_DETERRENCE_ENABLED = true;

/** Minimum ms between form render and submit for a plausibly human login. */
export const MIN_FORM_FILL_MS = 1500;

/** Fake network-latency range for rejections, so they mimic a real API failure. */
export const FAKE_FAILURE_DELAY_MIN_MS = 400;
export const FAKE_FAILURE_DELAY_MAX_MS = 900;
